






import Vue from "vue";
import Component from "vue-class-component";

@Component({
  props: {
    value: Number,
    max: Number
  }
})
export default class Gauge extends Vue {
  private value: Number;
  private max: Number;
  mounted() {
    setTimeout(() => {
      Highcharts.chart(
        "gauge",
        {
          chart: {
            type: "gauge",
            plotBorderWidth: 1,
            plotBackgroundImage: null,
            height: 200
          },

          title: {
            text: "Power Generating"
          },

          pane: [
            {
              startAngle: -45,
              endAngle: 45,
              background: null,
              center: ["50%", "145%"],
              size: 320
            }
          ],

          tooltip: {
            enabled: false
          },

          yAxis: [
            {
              min: 0,
              max: this.max * 1000,
              minorTickPosition: "outside",
              tickPosition: "outside",
              labels: {
                rotation: "auto",
                distance: 20
              },
              plotBands: [
                {
                  from: 0,
                  to: (this.max * 1000) / 5,
                  color: "#C02316",
                  innerRadius: "100%",
                  outerRadius: "105%"
                },
                {
                  from: this.max * 1000 - (this.max * 1000) / 3,
                  to: this.max * 1000,
                  color: "#009900",
                  innerRadius: "100%",
                  outerRadius: "105%"
                },
                {
                  from: (this.max * 1000) / 5,
                  to: this.max * 1000 - (this.max * 1000) / 3,
                  color: "#f8d568",
                  innerRadius: "100%",
                  outerRadius: "105%"
                }
              ],
              pane: 0,
              title: {
                text:
                  '(Watts)<br/><span style="font-size:8px">Power Generating</span>',
                y: -40
              }
            }
          ],

          exporting: {
            enabled: true,
            buttons: {
              contextButton: {
                menuItems: ["downloadPNG", "downloadSVG"]
              }
            }
          },

          plotOptions: {
            gauge: {
              dataLabels: {
                enabled: false
              },
              dial: {
                radius: "100%"
              }
            }
          },

          series: [
            {
              name: "Power Generated",
              data: [this.value],
              yAxis: 0
            }
          ]
        },
        1000
      );
    }, 1000);
  }
}
